import { Row, Col } from "react-bootstrap";

import classes from "./printInventory.module.scss";
import { ReactComponent as PrintIcon } from "@/assets/images/icons/Inventory/printer.svg";

import { formatMiles } from "@/services/Utils";

const PrintLotsTag = ({ selectLots, handlePrint }) => {
	return (
		<>
			<Row>
				<Col xs={12} md={12} className={classes.scrollDivTable}>
					<table className={classes.tableSimple}>
						<thead>
							<tr>
								<th>Código Lote</th>
								<th>Producto</th>
								<th>N° Factura</th>
								<th>Cant. Envases</th>
							</tr>
						</thead>
						<tbody>
							{selectLots.map((lot, i) => {
								return (
									<tr key={i}>
										<td>{`L${lot.code}`}</td>
										<td>{lot.tradename}</td>
										<td>{lot.dealer_number}</td>
										<td>{formatMiles(lot.quantity_inventories)}</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</Col>
			</Row>
			<Row>
				<Col xs={12} md={12}>
					<div className={`${classes.selecttags} ${classes.active}`} onClick={(_e) => handlePrint("select_lots")}>
						<PrintIcon className={classes.icon} />
						<span className={classes.title}>Imprimir Lotes Seleccioandos</span>
					</div>
				</Col>
			</Row>
		</>
	);
};

export default PrintLotsTag;
